import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { summaryService } from '../services/summaryService';

export const getWellWeeklySummary = createAsyncThunk(
  'summary/getWellWeeklySummary',
  async ({ wellCode, date, forceRefresh }, { rejectWithValue }) => {
    try {
      const response = await summaryService.getWellWeeklySummary(wellCode, date, forceRefresh);
      return response?.data || response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getOperatorWeeklySummary = createAsyncThunk(
  'summary/getOperatorWeeklySummary',
  async ({ operatorEmail, date, forceRefresh }, { rejectWithValue }) => {
    try {
      const response = await summaryService.getOperatorWeeklySummary(operatorEmail, date, forceRefresh);
      return response?.data || response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const summarySlice = createSlice({
  name: 'summary',
  initialState: {
    wellSummary: null,
    operatorSummary: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWellWeeklySummary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getWellWeeklySummary.fulfilled, (state, action) => {
        state.loading = false;
        state.wellSummary = action.payload;
      })
      .addCase(getWellWeeklySummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getOperatorWeeklySummary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOperatorWeeklySummary.fulfilled, (state, action) => {
        state.loading = false;
        state.operatorSummary = action.payload;
      })
      .addCase(getOperatorWeeklySummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = summarySlice.actions;

export default summarySlice.reducer;
